import SlideUpPopup from 'components/popUps/bottomPopUpV2'

interface IProps { 
  isOpen?: boolean
  onClose?: any
  children?: any
}

const DynamicPopup = ({ isOpen, onClose, children }: IProps) => {
  return (
    <SlideUpPopup isOpen={isOpen} onClose={onClose}>
      {children}
    </SlideUpPopup>
  )
}

export default DynamicPopup
